import { Injectable } from "@angular/core";
import { ChecklistOptionSet1, ChecklistOptionSet2, ChecklistResponseTypes } from "src/app/modules/shared/enums/checklists/checklistEnums";
import { ChecklistItemViewModel } from "src/app/modules/shared/models/checklists/checklistItemViewModel";
import { TranslateService } from "@ngx-translate/core";
import { T } from "src/assets/i18n/translation-keys";

@Injectable({
  providedIn: 'root',
})
export class ChecklistHelperService {
  constructor(private readonly translateService: TranslateService) {

  }

  isCompleted(item: ChecklistItemViewModel): boolean {
    let result = false;

    if (item.isNotApplicable) {
      result = true;
    } else if (item.responseType === ChecklistResponseTypes.Mark_as_Complete) {
      result = item.response === 'true';
    } else if (item.responseType === ChecklistResponseTypes.Text_Response) {
      result = item.response && item.response.length > 0;
    } else if (item.responseType === ChecklistResponseTypes.Numeric_Response) {
      result = item.response && Number(item.response) >= 0;
    } else {
      result = item.response !== undefined && parseInt(item.response) > 0;
    }
    return result;
  }

  isFailed(item: ChecklistItemViewModel): boolean {
    if (
      item.responseType === ChecklistResponseTypes.Options_Set_1 ||
      item.responseType === ChecklistResponseTypes.Options_Set_2
    ) {
      return (+item.response as ChecklistOptionSet1) === ChecklistOptionSet1.Fail || (+item.response as ChecklistOptionSet2) === ChecklistOptionSet2.Poor;
    }
    return false;
  }

  isUnsureOrFair(item: ChecklistItemViewModel): boolean {
    if (
      item.responseType === ChecklistResponseTypes.Options_Set_1 ||
      item.responseType === ChecklistResponseTypes.Options_Set_2
    ) {
      return (+item.response as ChecklistOptionSet1) === ChecklistOptionSet1.Unsure || (+item.response as ChecklistOptionSet2) === ChecklistOptionSet2.Fair;
    }
    return false;
  }

  public getGroupedChecklistItems(items: ChecklistItemViewModel[]): { groupTitle: string, checklistItems: ChecklistItemViewModel[] }[] {
    const groupedChecklistItems: { groupTitle: string; checklistItems: ChecklistItemViewModel[] }[] = [];
    items.forEach(checklist => {
            const title = checklist.checklistTemplateTitle ?? this.translateService.instant(T.defaultLocalizations.checklist_item.additional);
            let group = groupedChecklistItems.find(c => c.groupTitle === title)
            if(group) {
              if(!group.checklistItems)
               group.checklistItems = [];

              const matchingItem = group.checklistItems.find(c => c.id === checklist.id) || undefined;

              if(matchingItem) {
                group.checklistItems[group.checklistItems.indexOf(matchingItem)] = Object.assign({}, checklist);
              } else {
                group.checklistItems.push(checklist);
              }
            } else {
              group = {groupTitle: title, checklistItems: []};
              group.checklistItems.push(checklist);
              groupedChecklistItems.push(group);
            }
          });

          groupedChecklistItems.forEach(group =>  {
            group.checklistItems = group.checklistItems.sort((a, b) => a.viewOrder - b.viewOrder);
            group.checklistItems = group.checklistItems.slice();
          })

          return groupedChecklistItems;
  }
}
